import { createContext } from 'use-context-selector'
import { AdminOrganizationMemberContextProps } from './types'

export const AdminOrganizationMemberContext = createContext(
  {} as AdminOrganizationMemberContextProps
)
